import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { SERVICES, TECH } from "@/data/content";

export default function Services() {
  return (
    <section
      id="services"
      className="relative border-t border-white/10 bg-[#050505] py-24 md:py-40"
      data-testid="services-section"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <Reveal>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#0033ff]">
            03 — Capabilities
          </span>
          <h2 className="mt-6 max-w-4xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tighter text-[#f4f4f5] md:text-6xl lg:text-7xl">
            What we engineer.
          </h2>
        </Reveal>

        {/* Services grid */}
        <div className="mt-16 grid grid-cols-1 border-t border-l border-white/10 md:grid-cols-3">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.no}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="group relative border-b border-r border-white/10 p-8 transition-colors duration-500 hover:bg-white/[0.03] md:p-10"
              data-testid={`service-${s.no}`}
            >
              <div className="flex items-start justify-between">
                <span className="font-mono text-xs text-[#52525b]">{s.no}</span>
                <ArrowUpRight
                  size={20}
                  className="text-[#52525b] transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#0033ff]"
                />
              </div>
              <h3 className="mt-12 font-display text-2xl font-extrabold uppercase tracking-tight text-[#f4f4f5] md:text-3xl">
                {s.title}
              </h3>
              <p className="mt-4 font-mono text-sm leading-relaxed text-[#a1a1aa]">
                {s.body}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Technology showcase */}
        <div className="mt-24">
          <Reveal>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#52525b]">
              Platform expertise
            </span>
          </Reveal>
          <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
            {TECH.map((t, i) => (
              <Reveal key={t.name} delay={i * 0.12}>
                <div
                  className="group relative overflow-hidden border border-white/10"
                  data-testid={`tech-${t.name.toLowerCase()}`}
                >
                  <div className="relative h-64 overflow-hidden md:h-80">
                    <img
                      src={t.image}
                      alt={t.name}
                      className="h-full w-full scale-105 object-cover grayscale transition-all duration-1000 ease-out group-hover:scale-100 group-hover:grayscale-0"
                    />
                    <div className="absolute inset-0 bg-[#050505]/50 transition-opacity duration-500 group-hover:bg-[#050505]/20" />
                    {/* spotlight */}
                    <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100 [background:radial-gradient(circle_at_center,rgba(0,51,255,0.25),transparent_60%)]" />
                  </div>
                  <div className="flex items-start justify-between border-t border-white/10 bg-[#0c0c0c] p-6">
                    <div>
                      <h4 className="font-display text-xl font-extrabold uppercase tracking-tight text-[#f4f4f5]">
                        {t.name}
                      </h4>
                      <p className="mt-3 max-w-md font-mono text-xs leading-relaxed text-[#a1a1aa]">
                        {t.desc}
                      </p>
                    </div>
                    <span className="font-mono text-[10px] text-[#0033ff]">0{i + 1}</span>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
